// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__cfUj7 {
  overflow: hidden; }

.styles_tridot__7e6lX {
  height: 3rem; }
  .styles_tridot__7e6lX.styles_horizontal__pvTsQ {
    display: flex; }
  .styles_tridot__7e6lX > div {
    display: flex;
    width: 0rem;
    overflow: hidden;
    transition: 1s all;
    align-items: center;
    overflow-x: scroll;
    height: 3rem; }
  .styles_tridot__7e6lX.styles_optionsOriginRight__7Kq-x {
    flex-direction: row-reverse; }
  .styles_tridot__7e6lX.styles_optionsOriginLeft__jERrv {
    flex-direction: row; }
  .styles_tridot__7e6lX.styles_open__XLSGZ > div {
    width: 90%; }
  .styles_tridot__7e6lX.styles_open__XLSGZ > button svg {
    transform: rotate(180deg); }
  .styles_tridot__7e6lX.styles_horizontal__pvTsQ > button svg {
    transition: 0.75s all; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/ExpandableOptions/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAA;;AAGlB;EACE,YAAY,EAAA;EADd;IAII,aAAa,EAAA;EAJjB;IASI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY,EAAA;EAfhB;IAmBI,2BAA2B,EAAA;EAnB/B;IAsBI,mBAAmB,EAAA;EAtBvB;IA0BM,UAAU,EAAA;EA1BhB;IA6BM,yBAAyB,EAAA;EA7B/B;IAoCQ,qBAAqB,EAAA","sourcesContent":[".container {\n  overflow: hidden;\n}\n\n.tridot {\n  height: 3rem;\n\n  &.horizontal {\n    display: flex;\n\n  }\n\n  &>div {\n    display: flex;\n    width: 0rem;\n    overflow: hidden;\n    transition: 1s all;\n    align-items: center;\n    overflow-x: scroll;\n    height: 3rem;\n\n  }\n  &.optionsOriginRight {\n    flex-direction: row-reverse;\n  }\n  &.optionsOriginLeft {\n    flex-direction: row;\n  }\n  &.open {\n    &>div {\n      width: 90%;\n    }\n    & > button svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  &.horizontal {\n    &>button {\n      & svg {\n        transition: 0.75s all;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__cfUj7`,
	"tridot": `styles_tridot__7e6lX`,
	"horizontal": `styles_horizontal__pvTsQ`,
	"optionsOriginRight": `styles_optionsOriginRight__7Kq-x`,
	"optionsOriginLeft": `styles_optionsOriginLeft__jERrv`,
	"open": `styles_open__XLSGZ`
};
export default ___CSS_LOADER_EXPORT___;
